import axios from 'axios'

export const getPlaceName = async ({ lat, lng }: google.maps.LatLngLiteral) => {
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || ''
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`

  try {
    const response = await axios.get(url)
    const { results } = response.data
    if (results.length > 0) {
      return results[0].formatted_address
    }
    return ''
  } catch (error) {
    return ''
  }
}
